import styled from 'styled-components/native';

import { neutralDark, warrior, white } from '../../../constants/color';
import Image from '../../../elements/Image';
import Touchable from '../../../elements/Touchable';

export const S = {
  BG: styled.View`
    width: 100%;
  `,
  Container: styled.View`
    background-color: ${white};
    padding: 8px 0px;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    margin: 10px 15px;
    border-radius: 3px;
    shadow-color: ${neutralDark};
    shadow-opacity: 0.1;
    shadow-radius: 2.22px;
    shadow-offset: 1px 2px;
    elevation: 3;
  `,
  Button: styled(Touchable)<{ showRightBorder?: boolean }>`
    padding: 0px 30px;
    flex-direction: row;
    align-items: center;
  `,
  Text: styled.Text`
    color: ${warrior};
    font-size: 15px;
    margin: 0px 8px;
  `,
  Divider: styled.View`
    width: 1px;
    height: 100%;
    background-color: #d4d4d4;
  `,
  Image: styled(Image)`
    width: 24px;
    height: 24px;
  `,
};
